// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}
.Avatar > .avatar-container {
  overflow: hidden;
  border-radius: 100%;
  user-select: none;
}
.Avatar > .text {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/components/Avatar/Avatar.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AAEE;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAJ","sourcesContent":[".Avatar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n\n  > .avatar-container {\n    overflow: hidden;\n    border-radius: 100%;\n    user-select: none;\n  }\n\n  > .text {\n    flex-grow: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
